/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/ambulance_medium'
export default icon
